import React, { useState, useEffect, useRef } from "react";
import "../ListUsers/ListUser.css";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

function ListUsers() {
  // Dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  // const Download_Permission = useSelector((state) => state.AccessTocken.Download_Permission);

  //User Edit related selectors
  const user_id = useSelector((state) => state.user.user_id);
  const user_name = useSelector((state) => state.user.user_name);
  const user_firstName = useSelector((state) => state.user.user_firstName);
  const user_lastName = useSelector((state) => state.user.user_lastName);
  const user_email = useSelector((state) => state.user.user_email);
  const user_phone = useSelector((state) => state.user.user_phone);
  // const user_bu = useSelector((state) => state.user.user_bu);
  // const user_div = useSelector((state) => state.user.user_div);

  //Add user and Edit user related selectors
  const user_edit = useSelector((state) => state.user.user_edit);
  const bu_edit = useSelector((state) => state.user.bu_edit);
  const user_IsPane = useSelector((state) => state.user.userIsPane);
  const adduser_IsPane = useSelector((state) => state.user.adduserIsPane);

  //state hook for listuser API's
  const [userData, setUserData] = useState([]);
  const [userCount, setUserCount] = useState(null);

  //state hook for Add user API's
  const [newUser, setNewUser] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newFirstName, setNewFirstName] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [newDivisionId, setNewDivisionId] = useState(null);
  const [newRoleId, setNewRoleId] = useState(null);
  const [validate, setValidate] = useState("");
  const [exestingUserBoolen, setexestingUserBoolen] = useState(false);
  const [userValidated, setUserValidated] = useState(false);
  const [validateClick, setValidateClick] = useState(false);

  //state hook for Edit user API's
  const [idData, setidData] = useState(null);
  const [firstData, setfirstData] = useState(null);
  const [lastData, setlastData] = useState(null);
  const [emailData, setemailData] = useState(null);
  const [phoneData, setphoneData] = useState(null);
  const [businessunitData, setBusinessunitData] = useState("");
  // const [divEditData, setEditDisionData] = useState("");
  const [editDivisionId, setEditDivisionId] = useState(null);
  const [divisionName, setDivisionName] = useState("");
  const [businessunitName, setBusinessunitName] = useState("");
  const [editRoleid, setEditRoleid] = useState("");
  const [RoleName, setRoleName] = useState("");

  const [nameData, setNameData] = useState(null);
  const [divisionData, setdivisionData] = useState([]);
  const [buData, setBuData] = useState([]);
  const [roleData, setRoleData] = useState([]);

  // dependency
  const [IsDependent, setIsDependent] = useState(false);

  // For setting table height
  const [tableHeight, setTableHeight] = useState(false);

  // for filtering
  const [UserFilter, setUserFilter] = useState("");
  const [UserselData, setUserselData] = useState("");

  // when the filter is clicked
  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyUserfilter, setDummyUserfilter] = useState("");
  const [dummyUserselData, setDummyUserselData] = useState("");

  // spinner for API loading
  // const [apiLoad, setApiLaod] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  const user_filter = useSelector((state) => state.user.user_filter);

  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // height: 300,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, UserselData, UserFilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, UserselData, UserFilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, UserselData, UserFilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, UserselData, UserFilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      dispatch(sidebarReducer.apiLoad(true));
      setUserData([]);
      // setApiLaod(true);
      setPageSelected(pageNo);
      await axios
        .get(`cmsuser/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            //setApiLaod(false);
            setUserData(response.data.data.rows);
          } else if (response.status !== 200) {
            sessionStorage.clear();
            window.location.reload();
          }
        })
        .catch((err) => {
          sessionStorage.clear();
          window.location.reload();
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);

      if (!isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        //setApiLaod(true);
        await axios
          .get(
            `cmsuser/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              //setApiLaod(false);
              dispatch(sidebarReducer.apiLoad(false));
              setUserData(response.data.data.rows);
            } else if (response.status !== 200) {
              sessionStorage.clear();
              window.location.reload();
            }
          })
          .catch((err) => {
            sessionStorage.clear();
            window.location.reload();
          });
      } else if (isFilterIReset) {
        keyWord = dummyUserfilter;
        dispatch(sidebarReducer.apiLoad(true));
        // setApiLaod(true);
        await axios
          .get(
            `cmsuser/list/?page=${pageNo}&limit=${listLimit}&${dummyUserselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              //setApiLaod(false);
              dispatch(sidebarReducer.apiLoad(false));
              setUserData(response.data.data.rows);
            } else if (response.status !== 200) {
              sessionStorage.clear();
              window.location.reload();
            }
          })
          .catch((err) => {
            sessionStorage.clear();
            window.location.reload();
          });
      }
    }
  };

  // division response for Division Dropdown
  async function DivisionResponse(opt) {
    //setApiLaod(true);
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/listactive/${opt}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          return setdivisionData(response.data.data);
        } else if (response.status !== 200) {
          sessionStorage.clear();
          window.location.reload();
        }
      })
      .catch((err) => {
        sessionStorage.clear();
        window.location.reload();
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
      });
  }

  async function responseData() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
      .get(`cmsuser/list?page=${pageSelected}&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          setUserData(response.data.data.rows);
          setUserCount(response.data.data.count);
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    // BU response for BU Dropdown

    await axios
      .get(`businessunit/listactive`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          setBuData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    (Add_Permission === 1 || Edit_Permission === 1) &&
      (await axios
        .get(`roles/list/`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            // setApiLaod(false);
            let arr = response.data.data.rows;
            // delete arr[0];
            return setRoleData(arr);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
          dispatch(sidebarReducer.success(false));
          dispatch(sidebarReducer.failure(true));
        }));
  }

  //Add User API
  const newAddUser_data = {
    email: newEmail,
    username: newUser,
    firstname: newFirstName,
    lastname: newLastName,
    phone: newPhone,
    usertype: "platform",
    divisionid: newDivisionId,
    roleid: newRoleId,
  };

  const onAdduser = async (e) => {
    e.preventDefault();
    // setApiLaod(true);
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post(`cmsuser/add`, newAddUser_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          if (
            response.data.message ===
            `Username '${newAddUser_data.username}'is already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }
          dispatch(userReducer.adduser_IsPane(false));
          setValidate("");
          setNewUser("");
          setNewEmail("");
          setNewFirstName("");
          setNewLastName("");
          setNewPhone("");
          setNewDivisionId("");
          setNewRoleId("");
          setUserValidated(false);
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
      });
  };

  //Update User API
  const newUser_data = {
    email: emailData,
    username: nameData,
    firstname: firstData,
    lastname: lastData,
    phone: phoneData,
    divisionid: editDivisionId,
    roleid: editRoleid,
    usertype: "platform",
  };

  const onUpdate = async (user_id) => {
    //setApiLaod(true);
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`cmsuser/update/${user_id}`, newUser_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          if (
            response.data.message ===
            `Username '${newUser_data.username}' is already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else if (
            response.data.message ===
            `Email '${newUser_data.email}' is already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }
          dispatch(userReducer.user_edit(false));
          dispatch(userReducer.bu_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListUsers"));
          dispatch(userReducer.user_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
      });
  };

  //Delete user API
  const onDelete = async (user_id) => {
    //setApiLaod(true);
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post(`cmsuser/delete/${user_id}`, [], options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          dispatch(userReducer.user_edit(false));
          dispatch(userReducer.bu_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListUsers"));
          dispatch(userReducer.user_IsPane(false));
          dispatch(sidebarReducer.delete_success(true));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.delete_success(false));
      });
  };

  //Select a user from the table to get the pop up
  async function onEdit(item) {
    //setApiLaod(true);
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`cmsuser/list/${item.te_userid}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          setIsDependent(response.data.data.dependency);

          setidData(response.data.data.rows[0].te_userid);
          setfirstData(response.data.data.rows[0].te_firstname);
          setlastData(response.data.data.rows[0].te_lastname);
          setemailData(response.data.data.rows[0].te_useremail);
          setphoneData(response.data.data.rows[0].te_phone);
          setNameData(response.data.data.rows[0].te_username);
          setBusinessunitData(businessunitData); //V I
          setBusinessunitData(response.data.data.rows[0].te_buname);
          setBusinessunitName(response.data.data.rows[0].te_buname);
          setDivisionName(response.data.data.rows[0].te_divisionname);
          setEditDivisionId(response.data.data.rows[0].te_divisionid);
          setEditRoleid(response.data.data.rows[0].te_role_id);
          setRoleName(response.data.data.rows[0].te_role_name);

          dispatch(userReducer.user_id(response.data.data.rows[0].te_userid));
          dispatch(
            userReducer.user_firstName(response.data.data.rows[0].te_firstname)
          );
          dispatch(
            userReducer.user_lastName(response.data.data.rows[0].te_lastname)
          );
          dispatch(
            userReducer.user_email(response.data.data.rows[0].te_useremail)
          );
          dispatch(userReducer.user_phone(response.data.data.rows[0].te_phone));
          dispatch(
            userReducer.user_name(response.data.data.rows[0].te_username)
          );
          dispatch(userReducer.user_bu(response.data.data.rows[0].te_buname));
          dispatch(
            userReducer.user_division(
              response.data.data.rows[0].te_divisionname
            )
          );
          dispatch(
            userReducer.user_editroleid(response.data.data.rows[0].te_role_id)
          );
          dispatch(userReducer.user_IsPane(true));

          // dispatch(userReducer.user_filter(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  //Cancel button function
  const onCancel = (e) => {
    setidData(user_id);
    setfirstData(user_firstName);
    setlastData(user_lastName);
    setemailData(user_email);
    setphoneData(user_phone);
    setNameData(user_name);
    // setBusinessunitData(user_bu);
    // setEditDisionData(user_div);

    dispatch(userReducer.user_edit(false));
    dispatch(userReducer.bu_edit(false));
  };

  var addnameColor = "black";

  if (userValidated) {
    addnameColor = "green";
  } else {
    addnameColor = "red";
  }
  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {
      console.log("resp in return");
    };
    // eslint-disable-next-line
  }, [View_Permission]);

  async function onValidate() {
    //setApiLaod(true);
    setValidateClick(true);
    setexestingUserBoolen(true);
    if (newUser.length === 0 && newEmail.length > 0) {
      setValidate("Please enter Username.");
      setValidateClick(false);
    } else if (newUser.length > 0 && newEmail.length === 0) {
      setValidate("Please enter Email.");
      setValidateClick(false);
    } else if (newUser.length === 0 && newEmail.length === 0) {
      setValidate("Please enter Username and Email.");
      setValidateClick(false);
    } else if (newUser.length > 0 && newEmail.length > 0) {
      let checkUser = new RegExp(/[@!#$%^&*()\-/]/gm);
      // let checkUser = new RegExp(/(?=.*[0-9])(?=.*[!@#/\$%\^&\*])/gm);
      if (checkUser.test(newUser)) {
        setValidate("Please enter the valid username");
        setValidateClick(false);
      } else if (!newEmail.includes("@")) {
        setValidate("Please enter the valid email");
        setValidateClick(false);
      } else if (checkUser.test(newUser) && !newEmail.includes("@")) {
        setValidate("Please enter the valid username and email");
        setValidateClick(false);
      } else {
        await axios
          .post(
            `cmsuser/check`,
            {
              email: newEmail,
              username: newUser,
            },
            options
          )
          .then((response) => {
            if (response.data.status === 200) {
              //setApiLaod(false);
              if (
                response.data.message ===
                `Username '${newUser}' is already taken and Email '${newEmail}' is available.`
              ) {
                setValidate("Username taken.");
                setUserValidated(false);
                setValidateClick(false);
              } else if (
                response.data.message ===
                  `Username '${newUser}' is available and Email '${newEmail}' is already taken.` ||
                response.data.message ===
                  `Both Username '${newUser}' and Email '${newEmail}' is already taken.`
              ) {
                setValidate("Cannot create two users using one email.");
                setUserValidated(false);
                setValidateClick(false);
              } else {
                setValidate("Username available.");
                setUserValidated(true);
                setValidateClick(false);
              }
            }
          })
          .catch((err) => {
            setValidate(err.response.data.data[0].msg);
            setUserValidated(false);
            setValidateClick(false);
          });
      }
    }
  }

  // for filtering
  const handleSearch = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
      .get(
        // `userprofiles/list?page=${pageSelected}&limit=5&${TargetColomn}=${keyWord}`,
        `cmsuser/list?limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          setUserData(response.data.data.rows);
          setUserCount(response.data.data.count);
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const handleReset = (e) => {
    // e.preventDefault();
    responseData();
    setUserFilter("");
    setUserselData("");

    setDummyUserfilter("");
    setDummyUserselData("");
    setIsFilterIReset(false);

    dispatch(userReducer.user_filter(true));
  };

  const handleReset1 = (e) => {
    setUserFilter("");
    setUserselData("");
  };

  //Table and slidingpane width
  const ref = useRef(null);

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "84.6vh" }}>
              {/** ROW 1 for header */}
              <div className="row g-0 p-0 border-bottom">
                <div className="col">
                  <div
                    className=" g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>Users</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "123px",
                              }}
                              onClick={() => {
                                Add_Permission === 1 &&
                                  dispatch(userReducer.adduser_IsPane(true));
                                // dispatch(userReducer.user_filter(true));
                                handleReset();
                              }}
                            >
                              <span
                                className="ToolTipU"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Users
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add the user."
                                    : "You cannot add the user."}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown p-2">
                            {user_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(e, UserselData, UserFilter);
                                  setTableHeight(true);
                                  dispatch(userReducer.user_filter(false));
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "78px",
                                }}
                                onClick={() => {
                                  handleReset();
                                  setTableHeight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0 ">
                <div className="col ">
                  <div className="container-fluid g-0">
                    {!user_IsPane && !adduser_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "red",
                                    height: "80px",
                                    paddingTop: "20px",
                                    paddingLeft: "50px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={UserFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setUserFilter(val);
                                      setDummyUserfilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={UserselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setUserselData(val);
                                        setDummyUserselData(val);
                                      }}
                                    >
                                      <MenuItem
                                        value="te_username"
                                        size="small"
                                      >
                                        UserName
                                      </MenuItem>
                                      <MenuItem
                                        value="te_firstname"
                                        size="small"
                                      >
                                        First Name
                                      </MenuItem>
                                      <MenuItem
                                        value="te_lastname"
                                        size="small"
                                      >
                                        Last Name
                                      </MenuItem>
                                      <MenuItem
                                        value="te_useremail"
                                        size="small"
                                      >
                                        Email
                                      </MenuItem>
                                      <MenuItem value="te_phone" size="small">
                                        Mobile Number
                                      </MenuItem>
                                      <MenuItem value="te_buname" size="small">
                                        Business unit
                                      </MenuItem>
                                      <MenuItem
                                        value="te_divisionname"
                                        size="small"
                                      >
                                        Division
                                      </MenuItem>
                                      <MenuItem
                                        value="te_role_name"
                                        size="small"
                                      >
                                        Role
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                      // position: "relative",
                                      // top: "17px",
                                      // right: "-30px",
                                      // minWidth: "115px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(e, UserselData, UserFilter);
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      UserFilter.length > 0 &&
                                      UserselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      UserFilter.length > 0 &&
                                      UserselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {tableHeight ? (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "60vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table
                            className="table table-hover ListUserTable border-top-0 "
                            ref={ref}
                            style={{ fontSize: "12px", width: "100%" }}
                          >
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl No</th>
                                <th className="border">UserName</th>
                                <th className="border">First Name</th>
                                <th className="border">Last Name</th>
                                <th className="border"> Email</th>
                                <th className="border">Mobile No</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Division</th>
                                <th className="border">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userData.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={9}
                                    className=" border text-center mb-0"
                                  >
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                userData.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      handleReset();
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: `${
                                        item.te_userid === user_id &&
                                        user_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td
                                      className="border text-start"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_username}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_firstname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_lastname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_useremail}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_phone}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_divisionname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_role_name}
                                    </td>
                                    {/* {item.te_role_name === "Super Admin"
                                      ? "SUPER_USER"
                                      : item.te_role_name === "ADMIN" 
                                        ? "Admin"
                                        : item.te_role_name === "Power User"
                                          ? "POWER_USER"
                                          : item.te_role_name === "Remote User"
                                            ? "REMOTE_USER"
                                            : null}
                                  </td> */}
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    ) : (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "75vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table
                            className="table table-hover ListUserTable border-top-0 "
                            ref={ref}
                            style={{ fontSize: "12px", width: "100%" }}
                            disabled={user_edit ? true : false}
                          >
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border"> Sl No</th>
                                <th className="border">UserName</th>
                                <th className="border">First Name</th>
                                <th className="border">Last Name</th>
                                <th className="border">Email</th>
                                <th className="border">Mobile No</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Division</th>
                                <th className="border">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userData.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={9}
                                    className=" border text-center mb-0"
                                  >
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                userData.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      handleReset();
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: `${
                                        item.te_userid === user_id &&
                                        user_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_username}{" "}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_firstname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_lastname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_useremail}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_phone}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_divisionname}
                                    </td>
                                    <td className="border text-start roleNamee">
                                      {item.te_role_name}
                                      {/* {item.te_role_name === "SUPER_USER"
                                      ? "Super Admin"
                                      : item.te_role_name === "ADMIN"
                                        ? "Admin"
                                        : item.te_role_name === "POWER_USER"
                                          ? "Power User"
                                          : item.te_role_name === "REMOTE_USER"
                                            ? "Remote User"
                                            : null} */}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Page nation div */}
            {!apiLoad && (
              <div className="container">
                <div className="row main-footer">
                  <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                    Total Records: {userCount}
                  </div>
                  <div className="col-4 mt-2">
                    <div className="d-flex justify-content-center ">
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            leftEndArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== 1 && leftArrow();
                          }}
                        ></i>
                      </div>
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index1_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index1_pagenation,
                            UserselData,
                            UserFilter
                          );
                        }}
                      >
                        {index1_pagenation}
                      </div>
                      {noOfPages > 1 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index2_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index2_pagenation,
                              UserselData,
                              UserFilter
                            );
                          }}
                        >
                          {index2_pagenation}
                        </div>
                      )}
                      {noOfPages > 2 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index3_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index3_pagenation,
                              UserselData,
                              UserFilter
                            );
                          }}
                        >
                          {index3_pagenation}
                        </div>
                      )}
                      {noOfPages > 3 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index4_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index4_pagenation,
                              UserselData,
                              UserFilter
                            );
                          }}
                        >
                          {index4_pagenation}
                        </div>
                      )}
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== noOfPages && rightArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            rightEndArrow();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-2 ">
                    <div className="d-flex justify-content-end me-3">
                      <span>
                        <strong>Page {pageSelected} </strong> of{" "}
                        <strong>{noOfPages}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/** SlidingPan pop up for selecting and editing user data */}

          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="70%"
            hideHeader
            isOpen={user_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              onCancel();
            }}
          >
            <div
              className="container-fluid"
              style={{ backgroundColor: "#f2f3f5", height: "50px" }}
            >
              <div className="row" style={{ height: "54px" }}>
                <div className="col-3">
                  <div className="d-flex align-items-center ">
                    <div
                      className="px-1 pt-1"
                      onClick={() => {
                        dispatch(userReducer.user_id(null));
                        dispatch(userReducer.user_edit(false));
                        dispatch(userReducer.bu_edit(false));
                        dispatch(sidebarReducer.stringUpdate("ListUsers"));
                        dispatch(userReducer.user_IsPane(false));
                      }}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </div>
                    <div
                      className="border-start"
                      // className="px-2 pt-3 pb-1 border-secondary border-opacity-25 border-start"
                      style={{ height: "50px" }}
                    >
                      <h5 className="px-1 pt-3">
                        <strong>{user_name}</strong>
                      </h5>
                    </div>
                  </div>
                </div>

                <div className="col-9" style={{ height: "50px" }}>
                  <div
                    className="d-flex flex-row-reverse bd-highlight"
                    style={{ height: "50px" }}
                  >
                    <div
                      className="p-0 border-start"
                      // style={{ backgroundColor: "red" }}
                    >
                      {user_edit ? (
                        <button
                          className="button"
                          style={{
                            // paddingTop: "3px",
                            border: "none",
                            height: "50px",
                          }}
                          onClick={() => onUpdate(idData)}
                        >
                          <i className="bi bi-file-earmark-diff-fill"></i>
                          &nbsp;Save Changes
                        </button>
                      ) : (
                        <div>
                          <button
                            className="button"
                            style={{
                              zIndex: "1100",
                              // paddingTop: "3px",
                              border: "none",
                              height: "50px",
                            }}
                            onClick={() =>
                              Edit_Permission === 1 &&
                              dispatch(userReducer.user_edit(!user_edit))
                            }
                          >
                            <span
                              className="ToolTipU"
                              // style={{
                              //   backgroundColor: "var(--themes-color)",
                              // }}
                            >
                              <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                              Record
                              <span
                                className="ToolTipTextU"
                                style={{
                                  backgroundColor:
                                    Edit_Permission === 1
                                      ? "var(--themes-color)"
                                      : "red",
                                }}
                              >
                                {Edit_Permission === 1
                                  ? "You can edit the user."
                                  : "You cannot edit the user."}
                              </span>
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                    {user_edit && (
                      <div
                        className=" border-start "
                        style={{ height: "50px" }}
                        onClick={() => {
                          setPopUp(false);

                          onCancel();
                        }}
                      >
                        <button
                          className="button"
                          style={{
                            // paddingTop: "3px",
                            border: "none",
                            height: "50px",
                            minWidth: "85px",
                          }}
                        >
                          <i className="bi bi-arrow-clockwise"></i>&nbsp;Cancel
                          Changes
                        </button>
                      </div>
                    )}
                    <div className="p-0 border-start">
                      <button
                        className="button"
                        // data-bs-toggle="modal"
                        data-bs-target="#DeleteUser"
                        // data-backdrop="false"
                        style={{
                          zIndex: "1100",
                          border: "none",
                          height: "50px",
                          minWidth: "85px",
                        }}
                        onClick={() => {
                          Delete_Permission === 1 && setPopUp(true);
                        }}
                      >
                        <span
                          className="ToolTipU"
                          style={
                            {
                              // backgroundColor:
                              //   "var(--themes-color)"
                            }
                          }
                        >
                          <i className="bi bi-trash-fill"></i>&nbsp; Delete
                          record
                          <span
                            className="ToolTipTextU"
                            style={{
                              backgroundColor:
                                Delete_Permission === 1
                                  ? "var(--themes-color)"
                                  : "red",
                            }}
                          >
                            {Delete_Permission === 1
                              ? "You can delete the user."
                              : "You cannot delete the user."}
                          </span>
                        </span>
                      </button>
                    </div>
                    <div className="mode" style={{ padding: "12px" }}>
                      <div className="d-flex justify-content-center">
                        <i>
                          <strong style={{ color: "blue" }}>
                            {user_edit ? "Edit Mode" : "View Mode"}
                          </strong>
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row adduser" style={{ width: "101.1%" }}>
              <div className="col ms-3 mt-2">
                {/* <h5>Basic information:</h5> */}
                <form style={{ width: "99%" }}>
                  <div className="mb-3 mt-2">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="User name"
                      size="small"
                      variant="outlined"
                      value={nameData}
                      onChange={(e) => setNameData(e.target.value)}
                      disabled={user_edit ? false : true}
                      style={{ color: "black" }}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      size="small"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="First Name"
                      variant="outlined"
                      value={firstData}
                      onChange={(e) => setfirstData(e.target.value)}
                      disabled={user_edit ? false : true}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      size="small"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Last Name"
                      variant="outlined"
                      value={lastData}
                      onChange={(e) => setlastData(e.target.value)}
                      disabled={user_edit ? false : true}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      // error={editUserCheck}
                      type="email"
                      size="small"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Email"
                      variant="outlined"
                      value={emailData}
                      onChange={(e) => setemailData(e.target.value)}
                      disabled={user_edit ? false : true}
                    />
                  </div>
                  <div className=" mt-3 mb-3">
                    <TextField
                      type="text"
                      size="small"
                      inputProps={{ maxLength: 10 }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Phone Number"
                      variant="outlined"
                      value={phoneData}
                      onChange={(e) => setphoneData(e.target.value)}
                      disabled={user_edit ? false : true}
                    />
                  </div>
                  <div
                    className="mb-3"
                    onMouseDown={() => {
                      if (user_edit) setBusinessunitName("Business Unit");
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {businessunitName}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        // value={age}
                        disabled={user_edit ? false : true}
                        label="Business Unit"
                        variant="outlined"
                        onChange={(e) => {
                          dispatch(userReducer.bu_edit(true));
                          let val = e.target.value;
                          setBusinessunitData(e.target.value);
                          DivisionResponse(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.te_buid}
                            onClick={() => {
                              setBusinessunitName("Business Unit");
                            }}
                          >
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className="mb-3"
                    onMouseDown={() => {
                      if (user_edit && bu_edit) setDivisionName("Division");
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {divisionName}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled={bu_edit ? false : true}
                        size="small"
                        label="Division"
                        variant="outlined"
                        onChange={(e) => {
                          // setEditDisionData(e.target.value);
                          setEditDivisionId(e.target.value);
                          // setEditDisionData(e.target.value);
                        }}
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.te_divisionid}
                            onClick={() => {
                              setDivisionName("Division");
                            }}
                          >
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div
                      className="mt-3"
                      onMouseDown={() => {
                        if (user_edit) setRoleName("Role");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {RoleName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          label="Role"
                          variant="outlined"
                          onChange={(e) => {
                            setEditRoleid(e.target.value);
                          }}
                          disabled={user_edit ? false : true}
                        >
                          {roleData.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.te_role_id}
                              onClick={() => {
                                setRoleName("Role");
                              }}
                            >
                              {item.te_role_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <br />
                  <br />
                </form>
              </div>
            </div>
          </SlidingPane>

          {/** SlidingPan pop up for adding new user data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="70%"
            hideHeader
            isOpen={adduser_IsPane}
            onRequestClose={() => {
              setNewUser("");
              setNewEmail("");
              // triggered on "<" on left top click or on outside click
              // onCancel();
            }}
          >
            <div>
              <div
                className="d-flex align-items-center border"
                style={{ backgroundColor: "#f2f3f5" }}
              >
                <div
                  className="px-2 my-1"
                  onClick={() => {
                    dispatch(sidebarReducer.stringUpdate("ListUsers"));
                    setNewUser("");
                    setNewEmail("");
                    dispatch(userReducer.adduser_IsPane(false));
                    setValidate("");
                    setUserValidated(false);
                  }}
                >
                  <i className="bi bi-arrow-right"></i>
                </div>
                <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                  <h5 style={{ whiteSpace: "nowrap" }}>
                    <strong>Add Users</strong>
                  </h5>
                </div>
              </div>
              <form
                className="ps-3 py-3 pe-3"
                style={{ overflowY: "auto", height: "80vh" }}
                onSubmit={(e) => onAdduser(e)}
              >
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="UserName"
                    size="small"
                    variant="outlined"
                    required
                    // disabled={userValidated ? true : false}
                    onChange={(e) => {
                      setNewUser(e.target.value);
                      setexestingUserBoolen(false);
                      // setUserAvailable(false);
                      setUserValidated(false);
                    }}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    type="email"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Email"
                    size="small"
                    variant="outlined"
                    required
                    // disabled={userValidated ? true : false}
                    onChange={(e) => {
                      setNewEmail(e.target.value);
                      setexestingUserBoolen(false);
                      // setUserAvailable(false);
                      setUserValidated(false);
                    }}
                  />
                  <div className="my-2 mx-0 d-flex align-items-center">
                    <button
                      className="btn"
                      type="button"
                      required
                      style={{
                        backgroundColor: "var(--themes-color)",
                        color: "white",
                      }}
                      disabled={userValidated ? true : false}
                      onClick={() => {
                        onValidate();
                      }}
                    >
                      Validate
                    </button>
                    {exestingUserBoolen ? (
                      validateClick ? (
                        <div className="m-2 p-1 spinnerC"></div>
                      ) : (
                        <span style={{ color: addnameColor }}>
                          &nbsp;&nbsp;&nbsp;{validate}
                        </span>
                      )
                    ) : null}
                  </div>
                </div>

                <div className="mb-3">
                  <TextField
                    type="text"
                    inputProps={{ maxLength: 10 }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    size="small"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Phone Number"
                    variant="outlined"
                    required
                    onChange={(e) => setNewPhone(e.target.value)}
                  />
                  {newPhone.length < 10 && newPhone.length > 0 && (
                    <span className="text-danger">
                      *Please enter 10 digit mobile number.
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="First Name"
                    size="small"
                    variant="outlined"
                    required
                    onChange={(e) => setNewFirstName(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Last Name"
                    size="small"
                    variant="outlined"
                    required
                    onChange={(e) => setNewLastName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      required
                    >
                      Business Unit
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Business Unit"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => {
                        let val = e.target.value;
                        DivisionResponse(val);
                        dispatch(userReducer.bu_edit(true));
                      }}
                    >
                      {buData.map((item, index) => (
                        <MenuItem key={index} value={item.te_buid}>
                          {item.te_buname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      required
                    >
                      Division
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Division"
                      size="small"
                      variant="outlined"
                      required
                      onChange={(e) => setNewDivisionId(e.target.value)}
                      disabled={bu_edit ? false : true}
                    >
                      {divisionData.map((item, index) => (
                        <MenuItem key={index} value={item.te_divisionid}>
                          {item.te_divisionname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      required
                    >
                      Role
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Role"
                      size="small"
                      variant="outlined"
                      required
                      onChange={(e) => {
                        setNewRoleId(e.target.value);
                      }}
                    >
                      {roleData.map((item, index) => (
                        <MenuItem key={index} value={item.te_role_id}>
                          {item.te_role_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-5">
                  <button
                    className="btn btn-light text-white"
                    type="submit"
                    style={{ backgroundColor: "var(--themes-color)" }}
                    disabled={!userValidated ? true : false}
                  >
                    &nbsp;Submit
                  </button>
                </div>
              </form>
            </div>
          </SlidingPane>

          <Modal
            open={popUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This User has dependency, Cannot delete this User."
                      : "Are you sure you want to delete this User?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(idData);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>

          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListUsers;
